import type { SideView } from "@screener/protocol";
import { cn } from "@screener/uikit/lib/utils";
import { volumeBarFraction } from "./derive";

/**
 * Полоса объёма по постоянной логарифмической шкале §9 (1.9) — у строки
 * таблицы (`DensityRow`). Карточка с ТЗ 1.45 заливает строку от крупнейшей
 * плотности своей карточки (`cardFillFraction`) и эту полосу не использует.
 */

export interface VolumeBarProps {
  densityUsd: string;
  side: SideView;
  className?: string;
}

export function VolumeBar({ densityUsd, side, className }: VolumeBarProps) {
  const barPercent = volumeBarFraction(densityUsd) * 100;
  return (
    <span
      aria-hidden="true"
      className={cn("absolute", side === "bid" ? "bg-bid-wash" : "bg-ask-wash", className)}
      style={{ width: `${barPercent}%` }}
    />
  );
}
